module.exports = __webpack_public_path__ + "img/logo-systemes-solaires.92e3e9f1.png";